<template lang="pug">
  .container
    .info
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/success.png")
      p 恭喜！办理成功
    .ad
      p.color-red.font-big(style="margin-bottom: .4rem;") 免费18GB流量领取方式
      p.point 进入“冰蓝流量”公众号领取18GB流量
      p.color-red.font-big 截图保存下方二维码，进入公众号
      img.bl(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/bl.png")
      p.color-red.font-big 微信扫一扫关注公众号“冰蓝流量”
      el-button.btn-copy(@click="copyBLName", ref="blAccount") 一键复制微信号
      div(ref="blAccount", style="opacity: 0;") {{blAccount}}
</template>

<script>
export default {
  data() {
    return {
      shareNoticeVisiable: false,
      blAccount: 'meirxx'
    }
  },
  methods: {
    copyBLName() {
      let _range = document.createRange()
      _range.selectNode(this.$refs.blAccount)
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(_range);
      document.execCommand('Copy')
      window.getSelection().removeAllRanges()
    }
  }
}
</script>

<style lang="less" scoped>
.info{
  font-size: 1.1rem;
  text-align: center;
  margin-top: 4rem;
  .banner{
    width: 64px;
    height: 64px;
  }
}
.color-red{
  color: Red;
}
.font-big{
  font-weight: bold;
}
.ad{
  margin-top: 1rem;
  text-align: center;
  padding: 0 1rem;
  .bl{
    width: 100%;
  }
}
.btn-copy{
  color: #fff;
  background-color: red;
  border: 0;
  margin-top: .5rem;
}
.point{
  margin: .5rem 0;
  border: 2px dashed #d3d3d3;
  padding: .2rem;
}
</style>